import { marketingConversationHydratedSchema } from "@redotech/redo-marketing-common/conversation/marketing-conversation-definition";
import { marketingMessageSchema } from "@redotech/redo-marketing-common/message/marketing-message-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getConversationById = {
  name: "getConversationById" as const,
  input: z.object({ id: zExt.objectId() }),
  output: z.object({
    conversation: marketingConversationHydratedSchema.nullable(),
    messages: z.array(marketingMessageSchema),
  }),
};
